import { ReactNode, useEffect, useRef } from 'react'

import { useQueueConsumer } from 'src/contexts/QueueProvider'
import { asrTelemetryService } from 'src/services/AsrTelemetryService'

type TranscriptUpdateEventQueueExecutorProps = {
    children: ReactNode
}

export const TranscriptUpdateEventQueueExecutor = (props: TranscriptUpdateEventQueueExecutorProps) => {
    const { children } = props
    const [revisionQueueSize, revisionQueueExecute] = useQueueConsumer('revision')
    const [asrQueueSize, asrQueueExecute] = useQueueConsumer('asr')

    const asrDrainScheduledAtRef = useRef(0)

    // Records the scheduling timestamp that the ASR drain effect below consumes
    // to measure drain delay. React fires effects in declaration order, so this must come first.
    useEffect(() => {
        if (asrQueueSize) {
            asrDrainScheduledAtRef.current = Date.now()
        }
    }, [asrQueueSize])

    useEffect(() => {
        revisionQueueExecute()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [revisionQueueSize])

    useEffect(() => {
        if (asrDrainScheduledAtRef.current) {
            asrTelemetryService.recordDrainDelay(Date.now() - asrDrainScheduledAtRef.current)
            asrDrainScheduledAtRef.current = 0
        }
        asrQueueExecute()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [asrQueueSize])

    return <>{children}</>
}
